import { render, staticRenderFns } from "./Compose.ModuleOptions.vue?vue&type=template&id=92d9d1a4&scoped=true&"
import script from "./Compose.ModuleOptions.vue?vue&type=script&lang=js&"
export * from "./Compose.ModuleOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d9d1a4",
  null
  
)

export default component.exports